import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle'

function isOk(field) {
    return field === undefined;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0 ? intl.formatMessage({ id: 'required' }) : '';
}

class DialogName extends React.Component {

    state = {
        nombre: this.props.name ? this.props.name : '',
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (name) => (event) => {
        this.props.onClose(name);
    };

    isCorrect = () => {
        const { nombre } = this.state;
        return nombre && nombre.length > 0 ? true : false;
    };

    render() {
        const { nombre } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {this.props.title && <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>}
                <DialogContent style={{minWidth: 320}} className={''}>
                    <TextField
                        autoFocus
                        fullWidth
                        id={'nombre'}
                        name={'nombre'}
                        required
                        error={isOk(nombre)}
                        helperText={helperText(nombre, intl)}
                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                        className={'flex_full_row'}
                        value={nombre}
                        onChange={this.handleChange}
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose()} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(nombre)}
                        color="primary"
                        autoFocus
                        disabled={!this.isCorrect()}
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

DialogName.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(DialogName);


// WEBPACK FOOTER //
// ./src/components/dialogs/DialogName.js